module.exports = __webpack_public_path__ + "img/new_banner_es.9b4178ec.jpg";